import { Component } from '@angular/core';
import { GtmService } from '../shared/services/gtm.service';

@Component({
  selector: 'landing-layout-root',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss']
})
export class LandingLayoutComponent {
  constructor(private readonly gtmService: GtmService) {}
}
